import { ComponentsOverrides, Theme } from "@mui/material";

const MuiAutocomplete: ComponentsOverrides<Theme>["MuiAutocomplete"] = {
  inputRoot: {},
};

export default MuiAutocomplete;
